/**
 * GraphQL mutations for Hot Wheels & Wishlist.
 *
 * Verified against the live gateway (introspected 2026-08-03):
 *   - insertHotWheel(input: HotWheelInsertInput!)
 *   - updateHotWheel(where: HotWheelFilterInput!, input: HotWheelUpdateInput!)
 *   - deleteHotWheel(input: HotWheelDeleteInput!)
 *
 * Wishlist mutations follow the same shape.
 */

export const INSERT_HOT_WHEEL_MUTATION = `
  mutation InsertHotWheel($input: HotWheelInsertInput!) {
    insertHotWheel(input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_HOT_WHEEL_MUTATION = `
  mutation UpdateHotWheel($where: HotWheelFilterInput!, $input: HotWheelUpdateInput!) {
    updateHotWheel(where: $where, input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const DELETE_HOT_WHEEL_MUTATION = `
  mutation DeleteHotWheel($input: HotWheelDeleteInput!) {
    deleteHotWheel(input: $input) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;

export const INSERT_WISHLIST_MUTATION = `
  mutation InsertWishlist($input: WishlistInsertInput!) {
    insertWishlist(input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_WISHLIST_MUTATION = `
  mutation UpdateWishlist($where: WishlistFilterInput!, $input: WishlistUpdateInput!) {
    updateWishlist(where: $where, input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const DELETE_WISHLIST_MUTATION = `
  mutation DeleteWishlist($input: WishlistDeleteInput!) {
    deleteWishlist(input: $input) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;